/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(1.5),
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  popoverRoot: {
    marginTop: "5px",
  },
  listRoot: {
    padding: "0px",
  },
  listItem: {
    fontSize: "16px",
    minWidth: "300px",
    padding: "20px",
    "&::before": {
      content: `""`,
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "1px",
      backgroundColor: "#ECEFF1",
      top: "0",
      left: "15px",
    },
    "&:hover": {
      backgroundColor: "#ECEFF1",
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "10px",
    },
  },
  filterTitleAndIcon: {
    display: "flex",
    alignItems: "center",
  },
  popoverTitle: {
    padding: "20px",
  },
  groupByContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // flexGrow: "1",
    "&:hover": {
      cursor: "pointer",
    },
    "& > :last-child": {
      color: theme.palette.primary.main,
      marginLeft: "5px",
    },
    marginBottom: "10px",
  },
}));

const CompetitorGroupByComponent = ({ competitorsFilters, handleChange }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleGroupByClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (value) => {
    handleChange({ ...competitorsFilters, groupBy: { ...value } });
    setAnchorEl(null);
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    handleListItemClick({
      key: "category-company",
      label: "Category-Company",
    });
  }, []);

  return (
    <>
      <div
        role="presentation"
        onClick={handleGroupByClick}
        className={classes.groupByContainer}
      >
        <Typography variant="body2"> Group By: </Typography>
        <Typography variant="body2">
          {competitorsFilters.groupBy.label}
        </Typography>
      </div>
      <Popover
        className={classes.popoverRoot}
        open={Boolean(anchorEl)}
        onClose={handleOnClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          component="span"
          className={`${classes.popoverTitle} ${classes.filterTitleAndIcon}`}
        >
          <Typography variant="body1" className={classes.alignCenterFlex}>
            <b>Group By</b>
          </Typography>
        </Box>
        <List className={classes.listRoot}>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "category-company",
                label: "Category-Company",
              })
            }
            className={classes.listItem}
          >
            {/* <AiOutlineTags size={22} /> */}
            <Typography variant="body1">Category-Company</Typography>
          </ListItem>
          <ListItem
            onClick={() =>
              handleListItemClick({
                key: "category-company-brand",
                label: "Category-Company-Brand",
              })
            }
            className={classes.listItem}
          >
            <Typography variant="body1">Category-Company-Brand</Typography>
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

export default CompetitorGroupByComponent;
